import * as React from "react";
import { ConfirmDialog, Spinner } from "components/common";
import ProviderName from "ai-management/components/ProviderName";
import useConfiguredModelProviders from "ai-management/model-providers/hooks/useConfiguredModelProviders";
import DeleteConsequence from "ai-management/model-providers/delete/DeleteConsequence";
const DeleteModelProviderDialog = ({ provider, isDeleting, onConfirm, onCancel }) => {
  const { data: providers, isLoading } = useConfiguredModelProviders();
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      title: "Delete model provider",
      btnConfirmText: "Delete",
      btnConfirmDisabled: isLoading,
      isAsyncSubmit: true,
      isSubmitting: isDeleting,
      submitLoadingText: "Deleting...",
      onConfirm,
      onCancel
    },
    isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DeleteConsequence, { provider, providers }), /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to delete the model provider ", /* @__PURE__ */ React.createElement(ProviderName, { providerId: provider.provider }), "?"))
  );
};
export default DeleteModelProviderDialog;
